import { Link, useLocation } from "react-router-dom";
import { cn } from "@lib/utils";

export function DesktopNavLinks({ links }) {
  const location = useLocation();

  return (
    <div className="hidden lg:flex lg:gap-x-6 xl:gap-x-8">
      {links.map((item) => (
        <Link
          key={item.name}
          to={item.href}
          className={cn(
            "relative px-3 py-2 text-sm font-medium transition-all duration-300 rounded-md",
            location.pathname === item.href
              ? "text-primary shadow-sm bg-primary/5"
              : "text-gray-700 hover:text-primary hover:bg-gray-50"
          )}
        >
          {item.name}
          {location.pathname === item.href && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-primary to-primary-600 rounded-full" />
          )}
        </Link>
      ))}
    </div>
  );
}
